import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutComponent } from '../../layout/layout.component'
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { FirmService } from '../../../shared/services/firm.service';
import { ClientPortalService } from '../../../shared/services/client-portal.service';
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [LayoutComponent, RouterOutlet, ButtonModule, TooltipModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {


  showChatButton = false;

  constructor(private firmService: FirmService, private clientPortalService: ClientPortalService) { }
  // Add any additional methods or properties here
  // For example, you can add a method to handle button clicks


  onButtonClick() {
    if ((window as any).plugSDK.isPlugInitialized) {
      (window as any).plugSDK.toggleSearchAgent();
    }
  }

  async initPlugSDK(maxRetries = 10, interval = 500) {
    let retries = 0;
    //since session is not enabled right now only avaialble on paid MergeAccountComponent.
    const session = await this.firmService.getDevRevSession();
    const checkAndInit = () => {
      if ((window as any).plugSDK && typeof (window as any).plugSDK.init === 'function') {

        (window as any).plugSDK.init({
          app_id: 'don:core:dvrv-us-1:devo/1p2fHBIjgg:plug_setting/1',
          
          session_token: session.sessionToken,
          enable_session_recording: true
        });
        (window as any).plugSDK.onEvent((payload: any) => {
          if (payload.type === 'ON_PLUG_WIDGET_READY') {
            console.log('Plug widget is ready');
            this.showChatButton = true;
            (window as any).plugSDK.initSearchAgent();
          }
        });
        console.log('plugSDK initialized');
      } else if (retries < maxRetries) {
        retries++;
        setTimeout(checkAndInit, interval);
      } else {
        console.warn('plugSDK failed to load in time');
      }
    };

    checkAndInit();
  }
  ngOnInit() {
    // MP-5750: firms/getDevRevSession answers 403 for a CLIENT, which would log them out.
    if (!this.clientPortalService.isClientPortalUser()) {
      this.initPlugSDK();
    }
  }
}
